<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="搜索" v-model="search" @change="getData()"  style="width:300px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <el-card>
            <el-table :data="tableData" v-loading="table_load" height="630" style="width: 100%">
                 <el-table-column  prop="apply_type"    label="申请类型"   align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.apply_type == 1">企业合伙人</div>
                        <div v-else>个人合伙人</div>
                    </template>
                </el-table-column>
                <el-table-column  prop="corporate_name"    label="企业名称"   align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.apply_type == 1">{{scope.row.corporate_name}}</div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column  prop="batch"   label="姓名"   align="center">
                    <template slot-scope="scope">
                        <div type="info">{{scope.row.name}} {{scope.row.surname}}</div>
                    </template>
                </el-table-column>
                <el-table-column  prop="email"    label="邮箱"    align="center" > </el-table-column>
                <el-table-column  prop="phone"    label="电话"     align="center"></el-table-column>
                <el-table-column  prop="updated_at" label="通过时间"   width="180"  align="center" ></el-table-column>
                <el-table-column  prop="updated_at" label="状态"   width="180"  align="center" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" active-color="#13ce66" :active-value="1" :inactive-value="0" inactive-color="#ddd" @change="changeStatus(scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column  prop="" label="" align="center" width="250">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="viewDetail(scope.row)">查看详情</el-button>
                        <el-button size="mini" @click="goUser(scope.row)">查看绑定用户</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" :current-page.sync="page" :page-size="size" style="padding:10px" :total="total"  @current-change="loadPage"></el-pagination>
        </el-card>
        <el-dialog title="详情" center :visible.sync="dialog" width="1000px">
            <el-card class="m-bottom-4">
                <el-row class="m-bottom-2">
                    <el-col :span="11" class="row-height">申请类型：{{ detail.apply_type == 0 ? '个人合伙人': '企业合伙人' }}</el-col>
                    <el-col :span="13" class="row-height">企业名称：{{ detail.corporate_name ? detail.corporate_name : '-' }}</el-col>
                </el-row>
                <el-row class="m-bottom-2">
                    <el-col :span="11" class="row-height">姓名：{{ detail.surname}} {{ detail.name}}</el-col>
                    <el-col :span="13" class="row-height">邮箱：{{ detail.email}}</el-col>
                </el-row>
                <el-row class="m-bottom-2">
                    <el-col :span="11" class="row-height">电话：{{ detail.phone}}</el-col>
                    <el-col :span="13" class="row-height">通过时间：{{ detail.adopt_time}}</el-col>
                </el-row>
                <el-row class="m-bottom-2">
                    <el-col :span="11" class="row-height">钱包余额：${{ detail.agent_wallet.amount}}</el-col>
                </el-row>
            </el-card>
            <el-card class="m-bottom-4">
                <el-table :data="recordList" v-loading="table_load2" height="400" style="width: 100%">
                    <el-table-column  prop="created_at"  label="时间"   align="center"></el-table-column>
                    <el-table-column  prop="created_at"  label="类型"   align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.detailed_describe == 0">订单奖励</span>
                            <span v-if="scope.row.detailed_describe == 1">提现</span>
                            <span v-if="scope.row.detailed_describe == 2">售后扣除</span>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="created_at"  label="订单号"   align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.detailed_describe == 0">{{scope.row.item.title}}</span>
                            <span v-if="scope.row.detailed_describe == 2">{{scope.row.item.order.title}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="created_at"  label="余额"   align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.detailed_type == 0" style="color:rgb(67, 204, 116)">-${{scope.row.amount}}</span>
                            <span v-if="scope.row.detailed_type == 1" style="color:rgb(255, 113, 91)">+${{scope.row.amount}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background layout="prev, pager, next, jumper" :current-page.sync="page2" style="padding:10px" :total="total2"  @current-change="loadPage2"></el-pagination>
            </el-card>
        </el-dialog>
    </section>
</template>
<script>
import { partner, partner_detail, wallet_log, partner_audit } from '@/api/merchant.js'

export default {
    data() {
        return {
            search: '',
            table_load: false,
            page:1,
            total:0,
            size: 15,
            tableData:[],
            dialog: false,
            detail: {user:{},agent_wallet:{}},
            row: {},
            recordList: [],
            table_load2: false,
            page2: 1,
            total2: 0,
        }
    },
    methods: {
        getData(){
            let params = { 
                page: this.page,
                audit_status: 2
            }
            if(this.search != '') {
                params.keywords = this.search
            }
            this.table_load = true
            partner( params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }
            }).finally(() => {
                this.table_load = false
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        viewDetail(row) {
            partner_detail(row.id).then(res => {
                if(res) {
                    this.detail = res.data
                    this.dialog = true
                    this.page = 1
                    this.row = row
                    this.viewWalletRecord()
                }
            })
        },
        viewWalletRecord() {
            let params = {
                page: this.page2,
                user_id: this.row.uid,
                agent_id: this.row.id
            }
            this.table_load2 = true
            wallet_log(params).then(res => {
                if(res) {
                    this.recordList = res.data.data
                    this.total2 = res.data.total
                }
            }).finally(() => {
                this.table_load2 = false
            })
        },
        loadPage2(page){
            this.page2 = page;
            this.viewWalletRecord()
        },
        goUser(row) {
            let params = {
                user_id: row.uid,
                agent_id: row.id
            }
            this.$router.push({path: '/merchant/partner/user',query: {obj:JSON.stringify(params)}})
        },
        // 修改状态
        changeStatus(row) {
            let params = {
                status: row.status
            }
            partner_audit(row.id, params).then(res => {
                if(res) {
                    this.$message.success('修改成功')
                    this.getData()
                }
            })
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>
<style lang="less" scoped>
.row-height {
    height: 40px;
    line-height: 40px;
}
</style>